import Radio from "~/common/components/Radio";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { DateFormatType, formatDate } from "~/utils/DateFormatter";

export enum DeliveryOptionItem {
  PARTIAL = "partial",
  COMPLETE = "complete",
}
interface DeliveryOptionProps {
  onChange: (option: DeliveryOptionItem) => void;
  value: DeliveryOptionItem;
  estimatedDate?: Date;
}

export const DeliveryOption: FC<DeliveryOptionProps> = ({ onChange, estimatedDate, value }) => {
  const { t } = useTranslation();

  const isCompleteDelivery = value === DeliveryOptionItem.COMPLETE;
  return (
    <div className="scha__checkout__delivery-option-block">
      <div className="scha__checkout__delivery-option-block__list">
        <div
          className="scha__checkout__delivery-option-block__list__option"
          onClick={() => onChange(DeliveryOptionItem.PARTIAL)}
        >
          <div className="scha__checkout__delivery-option-block__list__option__radio">
            <Radio active={!isCompleteDelivery} />
          </div>
          <div className="scha__checkout__delivery-option-block__list__option__label">
            {t("checkoutPage.headers.deliveryOptions.partialDevivery")}
          </div>
        </div>
        <div
          className="scha__checkout__delivery-option-block__list__option"
          onClick={() => onChange(DeliveryOptionItem.COMPLETE)}
        >
          <div className="scha__checkout__delivery-option-block__list__option__radio">
            <Radio active={isCompleteDelivery} />
          </div>
          <div className="scha__checkout__delivery-option-block__list__option__label">
            {t("checkoutPage.headers.deliveryOptions.completeDelivery")}
            <br />
            {estimatedDate &&
              t("checkoutPage.headers.deliveryOptions.estimateDate", {
                date: formatDate(estimatedDate, DateFormatType.DATE),
              })}
          </div>
        </div>
      </div>
    </div>
  );
};
